import * as React from 'react';

import { ProjectClassMappingLabelRow } from 'src/containers/ProjectMapping/ProjectClassMappingLabelRow';
import { ProjectClassMappingPrimaryIdentifierRow } from 'src/containers/ProjectMapping/ProjectClassMappingPrimaryIdentifierRow';

export const ProjectClassMappingTopSection: React.VFC = () => {
  return (
    <div className="sd-project-mapping-grid--suggestions">
      <ProjectClassMappingPrimaryIdentifierRow />
      <ProjectClassMappingLabelRow />
    </div>
  );
};
